/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceDetailsForPoliciesRequest {
    getFixupPrototypeFunction() { return ComplianceDetailsForPoliciesRequest.fixupPrototype; }

    static newInstance(model: Partial<ComplianceDetailsForPoliciesRequest>): ComplianceDetailsForPoliciesRequest {
        let obj = Object.assign(new ComplianceDetailsForPoliciesRequest(), model);
        ComplianceDetailsForPoliciesRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceDetailsForPoliciesRequest>): ComplianceDetailsForPoliciesRequest {
        if (!model) return null;
        return ComplianceDetailsForPoliciesRequest.newInstance(<ComplianceDetailsForPoliciesRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceDetailsForPoliciesRequest) {
        if (!obj) return;

        models.ComplianceDetailsForPoliciesRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceDetailsForPoliciesRequest): boolean {
        Object.setPrototypeOf(obj, ComplianceDetailsForPoliciesRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Specify the tenant ID. This is a unique ID and can be retrieved using the List Tenants API
     */
    tenant_id: Array<string>;

    /**
     * Allowed services
     */
    services: Array<models.CloudServiceName>;

    /**
     * ID of the cloud account. This can be fetched from list cloud accounts API
     */
    cloud_accounts: Array<string>;

}
